module.exports = __webpack_public_path__ + "static/img/lijishiyong.481347d.png";


//////////////////
// WEBPACK FOOTER
// ./static/lijishiyong.png
// module id = QkbF
// module chunks = 1